import React, { useEffect, useState } from 'react'
import { useLazyGetUserReposQuery, useSearchUsersQuery } from '../store/github/github.api'
import { useDebounce } from '../hooks/debounce';
import RepoCard from '../componets/RepoCard';

type Props = {}

export function HomePage({}: Props) {
  const [search, setSearch] = useState('');
  const [dropdown, setDropdown] = useState(false);
  const debounced = useDebounce(search);
  const {isLoading,isError,data } = useSearchUsersQuery(debounced,{
    skip: debounced.length < 3,
    refetchOnFocus: true,
  })
  const [fetchRepos, {isLoading: areReposLoading,data: repos}] = useLazyGetUserReposQuery();

  useEffect(() => {
    setDropdown(debounced.length > 3 && data?.length! > 0)
  }, [debounced,data]) 
  
  const clickHandler= (username:string) =>{
    fetchRepos(username);
    setDropdown(false)
  }

  return (
    <div className='flex justify-center pt-10 mx-auto h-screen w-screen'>
        {isError && <p className='text-centet text-red-600'>Что то случилось...</p>}

        <div className='relative w-[569px]'>
            <input 
            className='border py-2 px-4 w-full h-[42px] mb-2'
             type="text"
             placeholder='Поиск по логину Github'
             value={search}
             onChange={e => setSearch(e.target.value)} />
             {dropdown &&(<ul className='list-one absolute top-[42px] left-0 right-0 max-h-[200px] overflow-y-scroll shadow-md bg-white'>
                {isLoading && <p className='text-center'>Загрузка</p>}
                {data?.map(user => (
                    <li
                    onClick={() => clickHandler(user.login)}
                    key={user.id}
                    className='py-2 px-4 hover:bg-gray-400 hover:text-white translate-colors cursor-pointer'
                    >{user.login}</li>
                ))}
             </ul>)}
             <div className="container">
            {areReposLoading && <p>Загрузка репозиториев</p>}
            {repos?.map(repo => <RepoCard repo={repo} key={repo.id}/>)}
            </div>
        </div>
     
    </div>
  )
}